// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"_1YgKh5-2vFDb7_6hPbmsB6","QuizWrapper":"_3xC_eHiHj9I7ixbcYFVuSc"};